'use strict';

//Prebyva
// - ulozime priznak neshody
// - pokud je povoleno navysovat, tak se ulozi priznak IsIncreasedAmount, na zaklade neho se pak upravi vydejka
// - pokud neni povoleno, tak se jen zaznamena neshoda
//Chybi
// - ulozime priznak neshody, rozpadneme polozku dle mnozstvi
// - na nove rozpaden polozce se zobrazi tlacitko Dovydano
//    - pokud mnozsvi je stejne, tak se dovyda vse
//    - pokud neni stejne, tak se dovyda co je a zbytek se ponizi na vydejce

/*global BasicProcess*/

function OutgoingControlProcess(containerId, settings) {
  BasicProcess.call(this, containerId, settings);

  this.init();
}

OutgoingControlProcess.prototype = $.extend({}, BasicProcess.prototype, {
  constructor: 'OutgoingControlProcess',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
